import _ from 'lodash';
import { options } from '../components/charts/options';

const getColor = (index) => {
  return options.colors[index];
};

export const ChartUtils = {

  colorDotStyleCreator: (index, size) => {
    const color = getColor(index);
    return {
      backgroundColor: color,
      width: size,
      minWidth: size,
      maxWidth: size,
      height: size,
      minHeight: size,
      maxHeight: size
    };
  },

  convertDataToHighchartsPieFormat: (data, total = undefined) => {
    if (!data) {
      return [];
    } else {
      const workingTotal = !!total ? total : _.sumBy(data, 'value');
      return _.map(data, ({ label, value }) => {
        let percentage = 0;
        if (workingTotal) {
          percentage = value / workingTotal;
          percentage *= 100;
          percentage = parseFloat(percentage.toFixed(2));
        }
        return [label, percentage];
      });
    }
  },

  isPieChartDataEmpty: (data) => {
    if (!data || data.length === 0) {
      return true;
    }

    let allZero = true;
    for (let i = 0; i < data.length; ++i) {
      const d = data[i];
      // Grab the percentage value
      if (d[1] !== 0) {
        allZero = false;
        break;
      }
    }

    return allZero;
  }
};
